<!-- 自建单 -->
<template>
  <div>
    <div class="detail-wrap">
      <el-form ref="editForm" :model="order">
        <div class="d-header clearfix">
          <div class="fl">
            <i class="el-icon-info" />
            {{ dataId ? "查看" : "新增" }}信息
          </div>
          <div class="fr">
            <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
          </div>
        </div>
        <div style=" overflow: unset !important; overflow-y: scroll !important; height: 100vh !important; ">
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box" style="overflow: hidden">
            <div class="d-item">
              <div class="title first">
                <b>用户信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>服务商
                    </th>
                    <td>
                      <!-- :disabled="this.showSelectSIte" -->
                      <el-input type="text" autocomplete="off" v-model="order.siteName" readonly>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showSiteDialog = true"></i>
                      </el-input>
                    </td>
                    <th>指派工程师</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="order.engineerName" >
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="doAssignEngineer"></i>
                      </el-input>
                    </td>
                    <th>关联工单号</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="order.parentOrderNo" >
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showPreconditionDialogFunc"></i>
                      </el-input>
                    </td>
                  </tr>
                  <tr>
                    <!-- <th>用户档案</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="order.profileNo" >
                        <i slot="suffix" class="el-input__icon el-icon-search" :disabled="isfromProfile"
                           @click="searchUser"></i>
                      </el-input>
                    </td> -->
                    <th>
                      <em class="f-red">*</em>
                      用户姓名
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="order.userName" :maxlength="30" clearable :disabled="isfromProfile" />
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      用户电话
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="order.userMobile" clearable style="" :disabled="isfromProfile"/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      期望上门时间
                    </th>
                    <td>
                      <el-date-picker v-model="order.wishBookDate" type="date"
                                      value-format="yyyy-MM-dd HH:mm:ss"
                                      placeholder="选择日期" @change="validateTime">
                      </el-date-picker>
                    </td>
                    <el-select v-model="order.wishBookPeriod" placeholder="请选择" clearable style="top: 5px">
                      <el-option label="08:00-12:00" value="08:00-12:00" />
                      <el-option label="12:00-18:00" value="12:00-18:00" />
                      <el-option label="18:00-21:00" value="18:00-21:00" />
                      <el-option label="00:00-23:59" value="00:00-23:59" />
                    </el-select>
                  </tr>
                  <tr>
                    <th><em class="f-red">*</em>地区</th>
                    <td colspan="3">
                      <el-cascader :props="areaProps" style="width: 96%" v-model="areaValues" :clearable="true"
                      :before-filter="areaBeforeFilter" @myInput="handleInput" @change="handleChange" ref="cascaderAddr" :options="areaOption">
                      </el-cascader>
                      <!-- <i @click="showItemPop = true" class="el-icon-search" style="margin: 2px 0 0 2px;"></i> -->
                    </td>
                    <th><em class="f-red">*</em>详细地址</th>
                    <td colspan="3">
                      <el-input type="text" autocomplete="off" v-model="order.userAddress" clearable maxlength="80" style="width: 96%!important" />
                      <!-- <i @click="showAreaSearchByMap = true " class="el-icon-search" style="margin: 2px 0 0 2px;"></i> -->
                    </td>
                    <!-- <th style="color: #0a84ff" >
                      远程费:
                    </th>
                    <td style="font-size: 13px;">
                      <el-popover placement="top-start" width="205" trigger="hover">
                        <div>
                          <p>开始地点: {{order.soOrderSettleDTO.createBeginAddress}}</p>
                          <p>开始经纬度: {{order.soOrderSettleDTO.createBeginLocation}}</p>
                          <p>结束地址: {{order.soOrderSettleDTO.createEndAddress}}</p>
                          <p>结束经纬度: {{order.soOrderSettleDTO.createEndLocation}}</p>
                        </div>
                        <span slot="reference" class="Instructions">{{order.soOrderSettleDTO.createLongDistance?order.soOrderSettleDTO.createLongDistance:0}}km | ￥{{order.soOrderSettleDTO.createLongDistanceAmount?order.soOrderSettleDTO.createLongDistanceAmount:0}}</span>
                      </el-popover>

                      <span @click="getLongDisMsg"  style="font-size: 12px;margin-left: 5px; padding: 5px 8px;border-radius: 4px;;background-color: #001E5A;color: #fffefe;">测算</span>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item" style="position: relative;height: 155px;">
              <div class="title first">
                <b>需求信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      服务类型
                    </th>
                    <td colspan="3">
                      <el-form-item prop="serviceTypeId" :rules="[{ required: true, trigger: 'blur' }]">
                      <el-cascader style="width: 100%;" placeholder="请选择" :props="serviceProps" clearable v-model="order.serviceTypeId"
                                   :show-all-levels="false"
                                   @change="changeServiceType" ref="cascaderServiceType" filterable :options="serviceTypeOption"></el-cascader>
                    </el-form-item>
                      <!-- <el-cascader style="width: 100%;" placeholder="请选择" :props="serviceProps" v-model="order.serviceTypeId"
                          @change="changeServiceType" ref="cascaderServiceType" filterable :options="serviceTypeOption"></el-cascader> -->
                    </td>
                    <th>
                    <em class="f-red">*</em>
                      购买渠道
                    </th>
                    <td>
                      <BuyChannelSelect style="width: 8vw;" :buy-channel-id.sync="order.buyChannelId"/>
                    </td>
                    <th>
                    <em class="f-red">*</em>
                    保修类型
                    </th>
                    <td>
                      <el-form-item prop="guaranteeType" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="order.guaranteeType" style="width: 8vw;" clearable>
                          <el-option label="保内" :value="1"/>
                          <el-option label="保外" :value="2"/>
                          <el-option label="师傅上门确认" :value="3"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      紧急度
                    </th>
                    <td>
                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select v-model="order.urger" style="width: 8vw;" clearable>
                          <el-option label="正常" :value="0"/>
                          <el-option label="紧急" :value="1"/>
                          <el-option label="特急" :value="2"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <!-- <th>
                      <em class="f-red">*</em>
                      结算类型
                    </th>
                    <td>
                      <el-select v-model="order.guaranteeType"  readonly  disabled placeholder="请选择" style="width: 8vw;">
                        <el-option label="结算" :value="1" />
                        <el-option label="不结算" :value="2" />
                      </el-select>
                    </td> -->
                    <!-- <th>
                     故障现象
                    </th>
                    <td>
                      <el-input  v-model="order.issueFaultName" readonly :disabled="isShowFault" :clearable="true"
                                 style="width: 8vw;">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="selectFault"></i>
                      </el-input>
                    </td> -->
                  </tr>
                  <tr style="position: absolute;">
                    <th>
                      <em class="f-red">*</em>
                      客户诉求</th>
                    <td colspan="7">
                      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
                        v-model="order.appeals" maxlength="80">
                      </el-input>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 产品信息 -->
            <div class="d-item">
              <div class="title first" style="position: relative;"><b>产品信息</b>
                <div style="position: absolute;right: 0;top: 5px;" v-show="isShowAddItem">
                  <el-button @click="addItem" type="primary" class="button-sty btn_zdy">新增产品</el-button>
                  <el-button @click="deleteItem(item, index)" type="danger" class="button-sty btn_zdy">删除产品</el-button>
                </div>
              </div>


              <el-form ref="form" :rules="formRules" :inline="true" label-width="7vw" key="1" style="margin-left:1px;">
                <div v-for="(item, index) in order.soOrderLineDTOList" :key="index"
                     style="border:1px solid #ededed;    margin: 5px; padding-top: 3px;">
                  <el-form-item label="品牌" :prop="'soOrderLineDTOList.' + index + '.name'" :rules="{
                    required: true, message: '品牌不能为空', trigger: 'blur'
                  }">
                    <el-select v-model="order.soOrderLineDTOList[index].brandId" style="width: 8vw;" clearable
                               @change="changeBrandId(index)"
                               filterable>
                      <el-option v-for="item in brands" :key="item.id" :label="item.brandName" :value="item.id">
                      </el-option>

                    </el-select>
                  </el-form-item>

                  <el-form-item label="产品大类" :prop="'soOrderLineDTOList.' + index + '.bigCategoryId'" :rules="{
                    required: true, message: '产品大类不能为空', trigger: 'blur'
                  }">
                    <el-select v-model="order.soOrderLineDTOList[index].bigCategoryId" style="width: 8vw;"
                               @change="changeBigCategorys($event, index)" clearable filterable>
                      <el-option v-for="item in bigCategorys" :key="item.id" :label="item.categoryName" v-if="item.categoryName !=='其它分类'"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="产品小类" :prop="'soOrderLineDTOList.' + index + '.smallCategoryId'">
                    <el-select v-model="order.soOrderLineDTOList[index].smallCategoryId" style="width: 8vw;"
                               @change="changeSmallCategorys($event, index)" clearable filterable>
                      <el-option v-for="item in smallCategorys[index]" :key="item.id" :label="item.categoryName"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="产品编码" :prop="'soOrderLineDTOList.' + index + '.itemCode'">
                    <el-input v-model="order.soOrderLineDTOList[index].itemCode" style="width: 8vw;" readonly>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="selectItem(index)"></i>

                    </el-input>
                  </el-form-item>
                  <el-form-item label="产品名称" :prop="'soOrderLineDTOList.' + index + '.itemName'">
                    <el-input v-model="order.soOrderLineDTOList[index].itemName" style="width: 8vw;" disabled>
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item label="销售类型" :prop="'orderLine.' + index + '.buyChannelId'"
                                :rules="{required: true, message: '销售类型不能为空', trigger: 'blur'}">
                    <el-select v-model="order.soOrderLineDTOList[index].buyChannelId"  style="width: 8vw;" @change="changeBuyChannelId"
                              clearable>
                      <el-option v-for="item in options"
                                 :key="item.id"
                                 :label="item.buyChannelName"
                                 :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                 <el-form-item label="数量" :prop="'soOrderLineDTOList.' + index + '.qty'" >
                   <el-input type="number" min="1" max="1" :disabled="true" v-model="order.soOrderLineDTOList[index].qty"
                              style="width: 8vw;"></el-input>
                  </el-form-item>
                  <el-form-item label="条码" :prop="'soOrderLineDTOList.' + index + '.barcode'">
                    <el-input type="text" :maxlength="50" v-model="order.soOrderLineDTOList[index].barcode"
                            style="width: 8vw;"></el-input>
                  </el-form-item>
                  <el-form-item label="购买时间" :prop="'soOrderLineDTOList.' + index + '.buyDate'" :rules="{
                    required: true, message: '购买时间不能为空', trigger: 'blur' }">
                    <el-date-picker v-model="order.soOrderLineDTOList[index].buyDate" type="date" placeholder="选择日期"
                                    style="width: 8vw;" :picker-options="pickerOptions"
                                    @change="getGuaranteeTypeByBuyDate(index)"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="购买商场" :prop="'soOrderLineDTOList.' + index + '.buyShop'">
                    <BuyShopSearch :buy-shop-id.sync="order.soOrderLineDTOList[index].buyShopId"
                                     :buy-shop.sync="order.soOrderLineDTOList[index].buyShop"
                                     style="width: 8vw;"/>
                  </el-form-item>

                  <!-- <el-form-item label="购买商场" :prop="'soOrderLineDTOList.' + index + '.buyShopId'"
                                :rules="{required: true, message: '购买商场不能为空', trigger: 'blur'}">
                    <buy-shop-search :buy-shop-id.sync="order.soOrderLineDTOList[index].buyShopId" :key="buyShopKey"
                                     :buy-shop.sync="order.soOrderLineDTOList[index].buyShop"
                                     :showParam="{id:order.soOrderLineDTOList[index].buyShopId,name:order.soOrderLineDTOList[index].buyShop,buyChannelId:order.soOrderLineDTOList[index].buyChannelId}"
                                     style="width: 9vw;" />
                  </el-form-item> -->
                  <!-- <el-form-item label="保修期限" :prop="'soOrderLineDTOList.' + index + '.periodEndDate'">
                    <el-date-picker v-model="order.soOrderLineDTOList[index].periodEndDate" type="date" disabled placeholder="选择日期"
                                    style="width: 8vw;" :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-form-item> -->
                  <!-- <el-form-item label="产品保修" :prop="'soOrderLineDTOList.' + index + '.guaranteeType'">
                    <el-select v-model="order.soOrderLineDTOList[index].guaranteeType" style="width: 9vw;" disabled>
                      <el-option label="保内" :value="1"/>
                      <el-option label="保外" :value="2"/>
                    </el-select>
                  </el-form-item> -->
                </div>
              </el-form>


            </div>
            <div style="height: 120px"></div>
          </div>
        </div>
      </el-form>

      <!-- 网点名称弹窗 -->
<!--      <nameDialog v-if="showPreconditionDialog2" @commit="commitSelectedRow" :visiable.sync="showPreconditionDialog2"-->
<!--        multi="true" />-->
    </div>

    <!-- 产品选择 -->
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedItemRow"
                        :visiable.sync="showPreconditionDialog" multi="true" :param="itemDialogParam"/>

    <orderDialog @closeD="closeD" :visible.sync="drawer" v-if="drawer" :row1="orderId" />

    <siteDialog v-if="showSiteDialog" @commit="commitSelectedSiteRow" :visiable.sync="showSiteDialog"
                 :param = "{isSelfSearch:1}" multi="true" />

      <!-- 工程师 -->
      <engineerDialog v-if="showChangeEngineerDialog" @commit="commitEngineer"
      :visiable.sync="showChangeEngineerDialog" multi="true" :excludeId="dataId" :siteId="this.order.siteId"
                      :is-assign="1" :isable="1" :areaId="this.order.areaId"/>

    <!-- <selfBuildUserDialog v-if="showUserDialog" @commit="commitUser" :visiable.sync="showUserDialog" multi="true" :siteId="this.order.siteId"/> -->

    <!-- 故障现象 -->
    <faultDialog v-if="showFaultDialog" @commitFaultSelected="commitFaultSelected" :visiable.sync="showFaultDialog"
                 multi="true" :param="faultDialogParam"/>

    <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit"
              :bigSiteId="this.bigSiteId" :siteId="this.siteId"/>

    <!-- <sraechAddressDialog :visiable.sync="showItemPop" v-if="showItemPop" :siteId="this.order.siteId" @addressList="addressList" /> -->

    <!-- <assetsDialog v-if="showAssetsDialog" @commit="commitAssets" :visiable.sync="showAssetsDialog" multi="true" :profile-no="this.order.profileNo" :index="this.selectIndex"/> -->

    <!-- <sraechAddressByMapDialog :visiable.sync="showAreaSearchByMap" @choose="chooseMapAddress" v-if="showAreaSearchByMap" :param="{userCity:order.userCity,userAddress:order.userAddress,isSearchBySite:1}" /> -->
  </div>
</template>
<script>

import request from "@/router/axios";

import api from "@/api/projectApi";
// import OrgSearch from "@/components/formItem/orgSearch.vue";
// import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import {
  default as detailsDialog,
  default as orderDialog,
} from "@/views/dialogCommon/detailsDialog.vue";
//产品
import itemDialog from "@/views/dialogCommon/itemDialog.vue";

// 服务商
import siteDialog from "./radioSiteDialog.vue";
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
// import siteDialog from "@/views/dialogCommon/radioSiteDialog.vue";
// import siteDialog from "./selfSelectSiteDialog.vue";

import { mapGetters } from "vuex";
// 工程师
import engineerDialog from '@/views/dialogCommon/radioEngineerDialog.vue';
// 故障现象
import faultDialog from "@/views/workorder/orderaccess/access/dialogFault.vue";
import preconditionDialog from "@/views/dialogCommon/itemDialog.vue";
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
// import current from "element-ui/packages/table/src/store/current";
// 购买渠道
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";
// 购买店铺
// import BuyShopSelect from "./buyShopSelect.vue";
// import BuyShopSearch from "./buyShopSelect.vue";

// import fa from "element-ui/src/locale/lang/fa";

// import siteDialog from "@/views/dialogCommon/selfSelectSiteDialog.vue";
// 地区搜索
// import sraechAddressDialog from '@/views/dialogCommon/sraechAddressDialog';
// import selfBuildUserDialog from "@/views/dialogCommon/radioUserDialog.vue";
// import assetsDialog from "@/views/dialogCommon/radioAssetsDialog.vue";
// 地区
// import commonArea from '@/components/commonArea/index.vue';

//根据地图查询地址
//import sraechAddressByMapDialog from '@/views/dialogCommon/sraechAddressByMapDialog';

import BuyShopSearch from "@/components/formItem/buyShopSearch.vue";
import store from "@/store";

export default {
  inject: ["reload"],
  name: "edit",
  props: {
    _dataId: [String, Number],
    _site: [Object],
  },
  mixins: [editPageMixins,siteMixins],
  components: {
    // commonArea,
    // sraechAddressDialog,
    orderPop,
    siteDialog,
    // BuyShopSelect,
    BuyChannelSelect,
    preconditionDialog,
    faultDialog,
    engineerDialog,
    // selfBuildUserDialog,
    // SitePopSearch,
    // OrgSearch,
    detailsDialog,
    // nameDialog,
    orderDialog,
    itemDialog,
    // assetsDialog,
    // sraechAddressByMapDialog,
    BuyShopSearch
  },
  watch: {
    // 'barcodeEntity': {
    //   handler(newVal, oldVal) {
    //     const serviceType = this.order.serviceTypeId
    //     if(!serviceType){
    //       this.$message.warning("请先选择服务类型!")
    //       return;
    //     }
    //     request({
    //       url: "/basic/basServiceType/getById",
    //       method: "post",
    //       data: {id: serviceType}
    //     }).then((res) => {
    //       console.log("服务类型")
    //       const type = res.data.data.businessType;
    //       if(type === 1){//安装不进行判断
    //         return
    //       }

    //     })
    //     console.log("监听条码")
    //     console.log(newVal)
    //     const { barcode, index } = newVal

    //     if(barcode === ""){
    //       return
    //     }
    //     request({
    //       url: "/basic/basCompanyBarcode/getInfoByBarcode",
    //       method: "get",
    //       params: {
    //         barcode: barcode,
    //       },
    //     }).then((res) => {
    //        const dd = res.data.data
    //        console.log("数据aaaaaaaaaaa")
    //        console.log(dd)
    //        if(!dd){
    //          this.$message.warning("当前用户的资产归属服务商不属于您,按公 司政策不允许自建单!")
    //          return;
    //        }
    //        const endDate = dd.endDate;
    //        const siteId = dd.siteId;
    //        if((siteId && siteId !== this.currentSiteData.id) ){
    //          this.$message.warning("当前用户的资产归属服务商不属于您,按公 司政策不允许自建单!")
    //           this.order.soOrderLineDTOList[index].barcode = ""
    //        }
    //        this.$set(this.order.soOrderLineDTOList[index], 'periodEndDate', endDate+'')
    //     });
    //   },
    //   deep: true, // 加这个属性，深度监听
    // },

  },
  data() {
    return {
      siteId:null,
      bigSiteId:null,
      showArea:true,
      inputWord:null,
      key:1,
      keyWord:null,

      buyShopKey:1,
      isfromProfile:false,
      // showAreaSearchByMap:false,
      options:[],
      canInputBarcode:true,
      businessType:null,
      selectAsset:'',
      showSiteDialog:false,
      companyMsg: {},
      currentSiteData:null,
      barcodeEntity:{barcode:"",index:0},
      showFaultDialog:false,
      //故障现象弹框传递参数
      faultDialogParam: [],
      //产品弹框传递参数
      itemDialogParam: {
        usable: 1
      },
      //指派网点传的参数
      assignSiteParam: {},
      //投诉性质
      complaintPropertys: [],
      //咨询类型
      consultTypes: [],
      //咨询细分
      consultTypeSubs: [],
      //表扬类型
      praiseTypes: [],
      userMobile: "",
          //服务类型
          serviceProps: {
        lazy: true,
        emitPath: false,
        // checkStrictly: true,
        lazyLoad: this.getServiceType
      },
      isShowFault:false,
      showChangeEngineerDialog: false,
      // showUserDialog:false,
      // showAssetsDialog:false,
      selectIndex:null,
      // showSelectSIte:false,
      order: {
        userName:'',//用户姓名
        userMobile:'',//用户电话
        wishBookDate:'',//期望上门时间
        areaId:'',//地区
        serviceTypeId:'',//服务类型
        serverTypeId:'',
        buyChannelId:'',
        // guaranteeType:'',//保修类型
        siteName:'',//服务商name
        siteId:'',//服务商id
        userAddress:'',//
        userProvice: null,
        userCity : null,
        userCounty : null,
        userTown : null,
        profileNo:null,
        bigSiteName:null,
        orderTypeId:0,
        userType:0,
        flowType: 1,
        guaranteeType: "",
        urger: 0,
        soOrderExtendDTO: {},

        soOrderLineDTOList: [
          // {brandId:"",bigCategoryId:"",smallCategoryId:"",qty:1,periodEndDate:"",buyShopId:"",barcode:""}
          {brandId:"",bigCategoryId:"",smallCategoryId:"",qty:1}
        ],
        soOrderSettleDTO:{
          createLongDistance:0,
          createLongDistanceAmount:0,
          createBeginAddress:"",
          createBeginLocation:"",
          createEndAddress:"",
          createEndLocation:""}
      },
      pickerOptions: {
        disabledDate(time) {
          let limit = Date.now() - 3600 * 1000 * 24;
          return (time.getTime() > Date.now()) // 设置禁止选今天以后的日子
        }
      },
            //品牌
            brands: [],
      //产品大类
      bigCategorys: [],
      serviceTypeOption:[],
      //产品小类
      smallCategorys: [],
      formRules: {},
      soOrderLineDTOList: [
          {brandId:"",bigCategoryId:"",smallCategoryId:"",qty:1}
        ],

      isShowAddItem: false,

      isSite: true,
      site: null,
      index: 0,
      areaValues: null,
      // showItemPop: false,
      flushKey:1,
      showOrderPop: false,
      isShow: false,
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad,
      },
      area: {
        country: null,
        province: null,
        city: null,
        county: null,
        town: null,
      },
      areaOption: [],
      assetId: null,
      callMobile: "",
      selectAddressData: null,
      selectItemData: null,

      // dictTypesVipLevel: [],
      // dictTypesCallInfo: [],
      // dictTypesNatureType: [],
      // dictTypesEducationLevel: [],
      // dictTypesCustIdentity: [],
      // dictTypesCustRisk: [],
      drawer: false,
      orderId: null,

      // getDataUrl1: "/basic/basCustAsset/getById",
      // addDataUrl: "/basic/basCustProfile/add",
      // updateDataUrl: "/basic/basCustProfile/update",
      // echoAddressUrl: "/basic/basArea/getAreaOptionByAreaId",
      // getTableDataUrl: "/basic/basCustAsset/getList",
      // getBrandListUrl: "/basic/snCompanyBrand/getBrandList",
      // getServiceTypeUrl: "/basic/basServiceType/getList",
      // getItemCategoryTypeUrl: "/basic/basItemCategory/getList",

      serviceSettleMethod:"",
      profileId:"",

      // formData: {
      //   value1: null,
      //   projectType: null,
      //   projectManager: null,
      //   projectRemark: null,
      //   projectNo: "",
      //   basCustRightsList: [],
      //   id: "",
      //   custType: 0, // 用户类型：0普通用户 、1、售前用户、2工程用户、3VIP用户、4经销商
      //   createType: 0, // 创建方式：0其他方式；1工单产生；2后台录入；3微信录入；4接口导入
      //   custName: "", // 用户名称
      //   orgId: "", // 机构ID，关联脚手架机构表.id
      //   orgName: "", // 机构名称,冗余字段
      //   orgIdPath: "", // 机构ID路径,冗余字段.重要
      //   siteName: "", // 服务网点名称,冗余字段
      //   email: null,
      //   custLabel: null,
      //   orderId: 0, // 源于工单ID,关联sp_order.id
      //   orderNo: "", // 源于工单号,冗余字段
      //   openId: "", // 微信openId
      //   openIdOther: "", // 其他微信openId
      //   miniOpenid: "", // 微信小程序unionId
      //   stat: 1, // 状态：1待审、2已审、9做废
        // projectManagerMobile: null,
        // bookStr:null,
        /** 性别:1男2女 */
        // sex: null,
        // /** VIP级别ID，关联脚手架数据字典项目表sys_dict_item.id */
        // vipLevel: null,
        // /** 来电信息ID，关联脚手架数据字典项目表sys_dict_item.id */
        // callInfo: null,
        // /** 性格类型ID，关联脚手架数据字典项目表sys_dict_item.id */
        // natureType: null,
        // /** 文化水平ID，关联脚手架数据字典项目表sys_dict_item.id */
        // educationLevel: null,
        // /** 用户身份ID，关联脚手架数据字典项目表sys_dict_item.id */
        // custIdentity: null,
        // /** 风险把控ID，关联脚手架数据字典项目表sys_dict_item.id */
        // custRisk: null,
        /** 来电号码 */

        /** 特别事项 */
        // specailRemark: null,

        // basCustAsseList: [],
        // basCustAddressList: [],
        // orderList: [],

        // basCustNetList: [],
        // basCustTitleList: [],
        // basCustAssetFilterList: [],
        // basCustRightsLineList: [],
      // },

      // tableData: [],
      activeName: "first",
      dialog: {
        one: false,
      },
      isEdit: false,
      tabIndex: "first",
      dataId: "",

      // showAreaDialog: false,
      // recordDialog: false,
      parentService:null,
      // showParts: true,
      // showProductCategoryDialog: false,
      showPreconditionDialog: false,
      // showFamilyMobileDialog: false,

      // areaObj: null,
      // areaObj3: null,
      obj: {},
      orgOptions: [],
      orgValue: [],
      // assetList: [],
      // partsList: [],
      // selectedData: null,
      // projectTypeList: [],
      indexNum: 0,
    };
  },

  computed: {
    ...mapGetters(["permissions"]),
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) {
      this.dataId = this._dataId;
    } else {
      this.isShow = false;
    }
    const userInfo = store.getters.userInfo;
    if(this.currentSiteData.snSiteInfoDTO.parentSiteId){
      this.siteId = this.currentSiteData.snSiteInfoDTO.siteId
    }else {
      this.bigSiteId = this.currentSiteData.snSiteInfoDTO.siteId
    }
    // this.userProfileEdit = this.permissions["userProfileEdit"];
    // this.userProfileCheck = this.permissions["userProfileCheck"];
    // this.userAssetUpdate = this.permissions["userAssetUpdate"];
  },

  mounted() {
    // this.getData();
    // this.loadOrgData();
    // this.getDictTypes();
    // this.initProjectType();
    this.getBrands();
    this.getBigCategorys();
    // this.getCompanyMsg();
    // this.echoAddress();
    // this.getCurrent();
    // this.loadBuyChannelData();
    // this.getTableData()
    // console.log(this._site, "this._site999");
    // console.log("网点信息")
    // console.log(this.currentSiteData)
    // if (this._site.snSiteInfo) {
      // this.site = this._site;
      // this.isSite = false;
      // this.order.orgName = this.site.snSiteInfo.orgName;
      // this.order.orgId = this.site.snSiteInfo.orgId;
      // this.order.orgIdPath = this.site.snSiteInfo.orgIdPath;
      // this.order.siteName = this.site.siteDto.userName;
      // console.log(this.order.orgName, this.site.snSiteInfo.orgName, "9586");
    // }
    console.log(this.isSite, "this.isSite的值");
  },
  methods: {
    // 工单弹窗选中
    orderCommit(row) {
      this.order.parentOrderNo = row.orderNo
    },
    showPreconditionDialogFunc() {
      this.showOrderPop = true
    },
    // changeBuyChannelId(){
    //   this.buyShopKey +=1
    // },
    //获取条码
    // selctBarcode(index){
    //   if (this.order.soOrderLineDTOList[index].barcode ){
    //     this.$http({
    //       url: api.soOrder.checkBarcodeUrl,
    //       method: 'post',
    //       data: {
    //         barcode: this.order.soOrderLineDTOList[index].barcode,
    //         buyDate: this.order.soOrderLineDTOList[index].buyDate,
    //         serviceTypeId:this.order.serverTypeId,
    //         profileId:this.order.profileId
    //       },
    //       isLoading: true,
    //       modalStrictly: true,
    //     }).then(response => {
    //       this.order.soOrderLineDTOList[index].isCommercial =response.data.data.isCommercial?response.data.data.isCommercial:0
    //       if (this.serviceSettleMethod == 3){
    //         this.order.guaranteeType = response.data.data.guaranteeType?response.data.data.guaranteeType:2
    //       }
    //       this.order.soOrderLineDTOList[index].guaranteeType = response.data.data.guaranteeType?response.data.data.guaranteeType:2
    //       if (response.data.data.buyChannelId){
    //         this.order.soOrderLineDTOList[index].buyChannelId = response.data.data.buyChannelId
    //       }

    //       this.order.soOrderLineDTOList[index].instDate =  response.data.data.installDate
    //       if (this.order.soOrderLineDTOList[index].bigCategoryId != response.data.data.bigCategoryId && response.data.data.bigCategoryId!=null) {
    //         this.order.soOrderLineDTOList[index].bigCategoryId = response.data.data.bigCategoryId;
    //         this.changeBigCategorys(response.data.data.bigCategoryId, index);
    //       }
    //       this.order.soOrderLineDTOList[index].smallCategoryId = response.data.data.smallCategoryId;
    //       this.order.soOrderLineDTOList[index].bigCategoryName = response.data.data.bigCategoryName;
    //       this.order.soOrderLineDTOList[index].smallCategoryName = response.data.data.smallCategoryName;
    //       this.order.soOrderLineDTOList[index].itemId = response.data.data.itemId;
    //       this.order.soOrderLineDTOList[index].itemName = response.data.data.itemName;
    //       this.order.soOrderLineDTOList[index].itemCode = response.data.data.itemCode;
    //       this.order.soOrderLineDTOList[index].outbound = response.data.data.unitName;
    //       if (response.data.data.periodDate){
    //         this.order.soOrderLineDTOList[index].periodEndDate =  response.data.data.periodDate
    //       }
    //       if (response.data.data.buyShopId){
    //         this.order.soOrderLineDTOList[index].buyShopId = response.data.data.buyShopId;
    //         this.order.soOrderLineDTOList[index].buyShop = response.data.data.buyShop;
    //         this.buyShopKey +=1
    //       }
    //     })
    //   }
    // },

    //选择根据地图查询出来的地址回显
    // chooseMapAddress(row){
    //   this.order.userAddress = row.address
    //   //调用逆地址编码
    //   var longitude = row.longitude
    //   var latitude = row.latitude
    //   this.$mask.open()
    //   this.$http({
    //     url: "/basic/soOrderIssue/getAddressMsgByLocation",
    //     method: "post",
    //     data: {
    //       longitude: longitude,
    //       latitude: latitude
    //     },
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then((response) => {
    //     if (response.data.code == 0) {
    //       this.areaOption = response.data.data.options
    //       this.areaValues = response.data.data.values
    //       this.order.areaId = response.data.data.areaId
    //       this.order.userProvice = response.data.data.userProvice;
    //       this.order.userCity = response.data.data.userCity;
    //       this.order.userCounty = response.data.data.userCounty;
    //       this.order.userTown = response.data.data.userTown;
    //       this.changeUserAddress()
    //     }
    //     this.$mask.close()
    //   }).catch(e => {
    //     console.error(e)
    //     this.$message.error("查询失败！");
    //     this.$mask.close()
    //   })

    // },
    // changeUserAddress(){
    //   this.order.soOrderSettleDTO.createLongDistance = null
    //   this.order.soOrderSettleDTO.createLongDistanceAmount = null
    //   this.order.soOrderSettleDTO.createBeginAddress = null
    //   this.order.soOrderSettleDTO.createBeginLocation = null
    //   this.order.soOrderSettleDTO.createEndAddress =null
    //   this.order.soOrderSettleDTO.createEndLocation = null
    // },


    // getLongDisMsg(){
    //   if (!this.order.areaId){
    //     this.$message({message: '请选择对应的省市区地址', type: 'warning'});
    //     return;
    //   }
    //   if (!this.order.userAddress){
    //     this.$message({message: '请输入详细地址地址', type: 'warning'});
    //     return;
    //   }
    //   var params = {areaId:this.order.areaId,userAddress:this.order.userAddress}
    //   this.$http({
    //     url: '/basic/soOrderIssue/getDisMsg',
    //     method: 'post',
    //     data: params,
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then(response => {
    //     this.order.soOrderSettleDTO.createLongDistance = response.data.data.longDis?response.data.data.longDis:0
    //     this.order.soOrderSettleDTO.createLongDistanceAmount = response.data.data.longDisAmount
    //     this.order.soOrderSettleDTO.createBeginAddress = response.data.data.startAddress?response.data.data.startAddress:""
    //     this.order.soOrderSettleDTO.createBeginLocation = response.data.data.startLng?response.data.data.startLng+","+response.data.data.startLat:""
    //     this.order.soOrderSettleDTO.createEndAddress = response.data.data.toAddress?response.data.data.toAddress:""
    //     this.order.soOrderSettleDTO.createEndLocation = response.data.data.toLng?response.data.data.toLng+","+response.data.data.toLat:""
    //   })
    // },
    //根据购买时间查询保修类型
    getGuaranteeTypeByBuyDate(index){
      var buydate = this.order.soOrderLineDTOList[index].buyDate
      const periodStartDate = new Date(buydate); // 复制原始日期
      periodStartDate.setFullYear(periodStartDate.getFullYear() + 1);
      this.$set( this.order.soOrderLineDTOList[index], 'periodEndDate', periodStartDate);
      this.changeGuaranteeType(index,periodStartDate)
    },
    changeGuaranteeType(index,periodDate){
      const now = new Date();
      var  periodStartDate = null;
      if (periodDate){
        periodStartDate = new Date(periodDate);
      }else if(this.order.soOrderLineDTOList[index].buyDate){
        periodStartDate = new Date(this.order.soOrderLineDTOList[index].buyDate);
        periodStartDate = periodStartDate.setDate(periodStartDate.getDate() + 365)
      }
      var guaranteeType = 1
      if (now>periodStartDate){
        guaranteeType = 2
      }else if(now<=periodStartDate){
        guaranteeType = 1
      }
      if (this.serviceSettleMethod == 3) {
        this.$set(this.order, 'guaranteeType', guaranteeType);
      }
      this.order.soOrderLineDTOList[index].guaranteeType = guaranteeType
    },

    // areaIdSure(data,type){
    //   if(type==0){
    //     console.log(data,type,"传过来的地址值0000");

    //     this.order.areaId=data.value
    //   // this.order.country = null;
    //     this.order.userProvice = data.pathLabels[0]       ;
    //     this.order.userCity =data.pathLabels[1];
    //     this.order.userCounty = data.pathLabels[2];
    //     this.order.userTown = data.pathLabels[3];
    //   }else if(type==1){
    //     console.log(data,type,"传过来的地址值11111");

    //     this.order.areaId=data.areaId

    //   // this.order.country = null;
    //     this.order.userProvice = data.userProvice;
    //     this.order.userCity =data.userCity;
    //     this.order.userCounty = data.userCounty;
    //     this.order.userTown = data.userTown;
    //   }

    // },
    // getAreaValues(val){
    //   this.order.areaId =  null
    //   this.changeUserAddress()
    //   this.order.userProvice = null;
    //   this.order.userCity = null;
    //   this.order.userCounty = null;
    //   this.order.userTown = null;
    //   this.$http({
    //     url: api.basArea.echoAddressUrl,
    //     method: 'post',
    //     data: {id: val}
    //   }).then(res => {
    //     // console.log(res)
    //     this.areaOption = res.data.data.options
    //     this.areaValues = res.data.data.values
    //     // this.area = res.data.data.names
    //     this.order.areaId =  res.data.data.areaId
    //     this.order.deliverProvince = res.data.data.userProvice;
    //     this.order.deliverCity = res.data.data.userCity;
    //     this.order.deliverCounty = res.data.data.userCounty;
    //     this.order.deliverTown = res.data.data.userTown;
    //   })
    // },
    // addressList(data) {
    //   console.log(data, "穿过i来");
    //   this.getAreaValues(data.id)
    // },
    selectItem(index) {
      this.showPreconditionDialog = true;
      this.itemDialogParam.brandId = this.order.soOrderLineDTOList[index].brandId;
      this.itemDialogParam.bigCategoryId = this.order.soOrderLineDTOList[index].bigCategoryId;
      this.itemDialogParam.smallCategoryId = this.order.soOrderLineDTOList[index].smallCategoryId;
      this.itemDialogParam.indexNum = index;
    },
    deleteItem(item, index) {
      // console.log(item,index,"indexde");
      if (this.order.soOrderLineDTOList.length > 1) {
        this.smallCategorys.splice(this.smallCategorys.length - 1, 1);
        this.order.soOrderLineDTOList.splice(this.order.soOrderLineDTOList.length - 1, 1);
      }
    },
    loadBuyChannelData() {
      this.$http.post(api.basBuyChannel.getListDataUrl, {siteId: this.order.siteId}).then(res => {
        this.options = res.data.data
      })
    },

    changeServiceType() {
      const serviceType = this.$refs["cascaderServiceType"].getCheckedNodes();
      if (serviceType != null && serviceType[0] != null && serviceType[0].value != null) {
        console.log(serviceType[0], "serviceType[0]")
        this.order.serverTypeId = serviceType[0].value;
        this.serviceTypedValue = serviceType[0].data.typedValue;
        if (serviceType[0].data.typedValue == 11) {//投诉
          this.setOrderMsgByChangeServiceType(11)
          this.isShowAddItem = false
        } else if (serviceType[0].data.typedValue == 4) {//咨询
          this.setOrderMsgByChangeServiceType(4)
          this.isShowAddItem = false
        } else if (serviceType[0].data.typedValue == 13) {//表扬
          this.setOrderMsgByChangeServiceType(13);
          this.isShowAddItem = false
        } else if (serviceType[0].data.typedValue == 2) {
          if (this.companyMsg.companyFixBeyondTwo == 1) {
            this.isShowAddItem = true;
          } else {
            this.isShowAddItem = false;
          }
          console.log("维修单据Type2")
          this.setOrderMsgByChangeServiceType(2);
          //是否显示故障现象
          this.isShowFault = false;
        } else if (serviceType[0].data.typedValue == 1) {
          if (this.companyMsg.companyInsBeyondTwo == 1) {
            this.isShowAddItem = true;
          } else {
            this.isShowAddItem = false;
          }
          this.setOrderMsgByChangeServiceType(1);
        } else {
          this.isShowAddItem = false;
          this.setOrderMsgByChangeServiceType(1);
        }
      } else {
        this.order.serverTypeId = "";
      }
      const panelRefs = this.$refs.cascaderServiceType.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    //服务类型改变重新设置值
    setOrderMsgByChangeServiceType(type) {
      this.serviceType = type;
      this.isShowFault = true;
      this.order.issueFaultId = "";
      this.order.issueFaultName = "";
      if (type != 11) {//不是投诉清空投诉相关的信息
        this.order.soOrderExtendDTO.complaintObjectName = "";
        this.order.soOrderExtendDTO.complaintProperty = "";
        this.order.complaintTypeId = "";
        this.complaintType = "";
      } else {
        //获取对应的客诉类型
        this.getComplaintType();
        //获取对应的投诉性质
        this.getComplaintPropertys();
      }
      if (type != 13) {//不是表扬清空表扬相关的信息
        //表扬
        this.order.soOrderExtendDTO.praiseObjectName = "";
        this.order.soOrderExtendDTO.praiseType = "";
      } else {
        //获取对应的表扬类型
        this.getPraiseType();
      }
      if (type != 4) {//不为咨询清空咨询相关的信息
        //咨询
        this.order.soOrderExtendDTO.consultType = "";
        this.order.soOrderExtendDTO.consultTypeSub = "";
      } else {
        //获取对应的咨询类型
        this.getConsultTypes();
      }
      if (type != 1) {
        this.order.guaranteeType = 3;
        // this.order.urger = 0;
      }
    },
    // changeServiceType() {
    //   const serviceType = this.$refs["cascaderServiceType"].getCheckedNodes();
    //   console.log("服务类型：")
    //   console.log(serviceType);
    //   const parentServiceName = serviceType[0].parent.data.label;
    //   this.parentService = parentServiceName;
    //   console.log(parentServiceName)
    //   if (serviceType != null && serviceType[0] != null && serviceType[0].value != null) {
    //     this.businessType = serviceType[0].data.typedValue;
    //     this.serviceSettleMethod = serviceType[0].data.settleMethod
    //     if (serviceType[0].data.settleMethod && serviceType[0].data.settleMethod != 3){
    //       this.formData.guaranteeType = serviceType[0].data.settleMethod
    //     }else{
    //       this.changeGuaranteeType(0,this.order.soOrderLineDTOList[0].periodEndDate)
    //     }
    //     if(serviceType[0].data.typedValue === 1 || serviceType[0].data.label.includes('以旧换新') ){//安装类型，手动填写条码
    //       this.canInputBarcode = false;
    //       this.selectAsset = '请手动填写条码';
    //       this.order.guaranteeType = 1;
    //     }else{
    //       this.order.guaranteeType = 2;
    //       this.canInputBarcode = true;
    //       this.selectAsset = '点击放大镜选择';
    //       // if(this.order.soOrderLineDTOList){//情况barcode
    //       //   let a = [];
    //       //   a = this.order.soOrderLineDTOList;
    //       //   a.forEach(item => {
    //       //     item.barcode = null;
    //       //   })
    //       // }
    //     }
    //     if(serviceType[0].label === '安装'){
    //       this.order.issueFaultName = null;
    //       this.isShowFault = true;
    //     }else{
    //       if(this.order.soOrderLineDTOList.length > 1){
    //         this.order.soOrderLineDTOList = []
    //         this.addItem()
    //       }
    //       this.isShowFault = false;
    //     }
    //     this.order.serverTypeId = serviceType[0].value;
    //     this.serviceTypedValue = serviceType[0].data.typedValue;
    //     if (serviceType[0].data.typedValue == 11) {//投诉
    //       this.setOrderMsgByChangeServiceType(11)
    //       this.isShowAddItem = false
    //     } else if (serviceType[0].data.typedValue == 4) {//咨询
    //       this.setOrderMsgByChangeServiceType(4)
    //       this.isShowAddItem = false
    //     } else if (serviceType[0].data.typedValue == 13) {//表扬
    //       this.setOrderMsgByChangeServiceType(13);
    //       this.isShowAddItem = false
    //     } else if (parentServiceName === '维修') {//维修
    //       this.setOrderMsgByChangeServiceType(1);
    //       this.checkBuyDate();
    //       if (this.companyMsg.companyFixBeyondTwo === 1) {
    //         this.isShowAddItem = true;
    //       } else {
    //         this.isShowAddItem = false;
    //       }
    //       //是否显示故障现象
    //       this.isShowFault = false;
    //     } else if (serviceType[0].data.typedValue == 1) {
    //       if (this.companyMsg.companyInsBeyondTwo === 1) {
    //         this.isShowAddItem = true;
    //       } else {
    //         this.isShowAddItem = false;
    //       }
    //       this.setOrderMsgByChangeServiceType(1);
    //     } else {
    //       this.isShowAddItem = false;
    //       this.setOrderMsgByChangeServiceType(1);
    //     }
    //   } else {
    //     this.order.serverTypeId = "";
    //   }
    //   const panelRefs = this.$refs.cascaderServiceType.$refs.panel
    //   if (panelRefs.activePath.length !== 0) {
    //     panelRefs.activePath.forEach(item => {
    //       if (item.children.length === 0) {
    //         panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
    //       }
    //     })
    //   }
    // },

    checkBuyDate(){
      let c  = [];
      c = this.order.soOrderLineDTOList;
      let i1 = new Date();
      c.forEach(item => {
        if(item.buyDate){
          let nd = new Date(item.buyDate);
          let dd = Math.abs(i1.getTime() - nd.getTime())/(1000*60*60*24);
          if(this.businessType === 2 && dd <= 365){
            this.order.guaranteeType = 1
          }
          if(this.businessType === 2 && dd > 365){
            this.order.guaranteeType = 2
          }
        }
      })
    },
    // getCompanyMsg() {
    //   request({
    //     url: '/basic/soOrderIssue/getCompanyMsg',
    //     method: 'post',
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then(response => {
    //     console.log("请求------")
    //     console.log(response.data.data)
    //     this.companyMsg = response.data.data
    //   })
    // },
    changeBigCategorys(val, index) {
      console.log("this.bigCategorys------------",this.bigCategorys)
      var bigCategory = this.bigCategorys.find(item => item.id === this.order.soOrderLineDTOList[index].bigCategoryId)
      console.log("bigCategory------------",bigCategory)
      this.order.soOrderLineDTOList[index].bigCategoryName = bigCategory.categoryName
      // this.order.soOrderLineDTOList[index].bigCategoryName = this.bigCategorys.find(
      //   (option) => option.key === this.order.soOrderLineDTOList[index].bigCategoryId
      // ).categoryName;
      this.order.soOrderLineDTOList[index].smallCategoryId = "";
      this.order.soOrderLineDTOList[index].smallCategoryName =""
      this.order.soOrderLineDTOList[index].itemId = "";
      this.order.soOrderLineDTOList[index].itemCode = "";
      this.order.soOrderLineDTOList[index].itemName = "";
      this.order.soOrderLineDTOList[index].entId = "";
      request({
        url: '/basic/basItemCategory/getChildrens',
        method: 'post',
        data: {
          usable: 1,
          categoryType: 1,
          parentId: val
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$set(this.smallCategorys, index, response.data.data);
        // this.smallCategorys[index] =response.data.data
        //重选产品分类清空故障现象
        this.order.issueFaultId = "";
        this.order.issueFaultName = "";
      })
    },
    //服务类型改变重新设置值
    // setOrderMsgByChangeServiceType(type) {
    //   this.serviceType = type;
    //   this.isShowFault = true;
    //   this.order.issueFaultId = "";
    //   this.order.issueFaultName = "";
    //   if (type != 11) {//不是投诉清空投诉相关的信息
    //     this.order.soOrderExtendDTO.complaintObjectName = "";
    //     this.order.soOrderExtendDTO.complaintProperty = "";
    //     this.order.complaintTypeId = "";
    //     this.complaintType = "";
    //   } else {
    //     //获取对应的客诉类型
    //     this.getComplaintType();
    //     //获取对应的投诉性质
    //     this.getComplaintPropertys();
    //   }
    //   if (type != 13) {//不是表扬清空表扬相关的信息
    //     //表扬
    //     this.order.soOrderExtendDTO.praiseObjectName = "";
    //     this.order.soOrderExtendDTO.praiseType = "";
    //   } else {
    //     //获取对应的表扬类型
    //     this.getPraiseType();
    //   }
    //   if (type != 4) {//不为咨询清空咨询相关的信息
    //     //咨询
    //     this.order.soOrderExtendDTO.consultType = "";
    //     this.order.soOrderExtendDTO.consultTypeSub = "";
    //   } else {
    //     //获取对应的咨询类型
    //     this.getConsultTypes();
    //   }
    //   if (type != 1) {
    //     this.order.guaranteeType = 3;
    //   }
    // },
    doAssignEngineer(){
      if(!this.order.siteId){
        this.$message({message: '请先选择服务商', type: 'warning'});
        return
      }
      this.showChangeEngineerDialog = true
    },

    // searchUser(){
    //   if(!this.order.siteId){
    //     this.$message({message: '请先选择服务商', type: 'warning'});
    //     return
    //   }
    //   this.showUserDialog = true
    // },
    // handleDateChange(val){
    //   let a = val
    //   let i =  val
    //   console.log("改变购买日期")
    //   console.log(val)
    //   let nd = new Date(i)
    //   let i1 = new Date();
    //   let dd = Math.abs(i1.getTime() - nd.getTime())/(1000*60*60*24);
    //   console.log(dd)
    //   if(this.parentService === '维修' && dd <= 365){
    //     this.order.guaranteeType = 1
    //   }
    //   if(this.parentService === '维修' && dd > 365){
    //     this.order.guaranteeType = 2
    //   }
    //   val = a;
    // },
    // searchAssets(index){
    //   if(!this.order.profileNo){
    //     this.$message({message: '请先选择用户档案', type: 'warning'});
    //     return
    //   }
    //   if(!this.businessType){
    //     this.$message({message: '请先选择服务类型', type: 'warning'});
    //     return
    //   }
    //   console.log("搜索资产:"+this.businessType)
    //   if(this.businessType && this.businessType === 1){
    //     return;
    //   }
    //   this.selectIndex = index;
    //   console.log("搜索资产:"+this.selectIndex)
    // },

    //获取服务类型
    getServiceType(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: '/basic/basServiceType/getList',
        method: 'post',
        data: {
          parentId: node.value,
          isShowSiteIssue: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.serviceTypeName,
          typedValue: item.businessType,
          leaf: !item.hasChild,
          settleMethod:item.settleMethod
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },
    commitEngineer(data){
      console.log("data-工程师", data);
      this.order.engineerName=data.engineerName;
      this.order.engineerId = data.id;
    },
    // commitAssets(data){
    //   console.log("data-用户", data);
    //   let index = data.index;
    //   this.order.soOrderLineDTOList[index].barcode = data.barcode;
    //   //判断保内保外
    //   const periodEndDate = data.periodEndDate;
    //   this.changeGuaranteeType(index,periodEndDate)
    //   // const now = new Date();
    //   // const pDate = new Date(periodEndDate)
    //   // if(this.businessType === 2 && now <= pDate){
    //   //   this.order.guaranteeType = 1;
    //   // }else{
    //   //   this.order.guaranteeType = 2;
    //   // }
    // },
    // showSiteDialogMethod(){
    //   if(this.showSelectSIte === true){
    //     return
    //   }
    //   this.showSiteDialog = true
    // },
    // commitUser(data){
    //   this.isfromProfile = true
    //   console.log("data-用户", data);
    //   this.profileId = data.id
    //   this.order.userName=data.custName;
    //   this.order.userMobile = data.callMobile;
    //   this.order.userAddress = data.custAddress;
    //   this.order.profileNo = data.profileNo;
    //   this.order.deliverProvince = data.custProvince;
    //   this.order.deliverCity = data.custCity;
    //   this.order.deliverCounty =  data.custCounty;
    //   this.order.deliverTown =  data.custTown;
    //   this.order.soOrderLineDTOList[0].barcode = data.barcode
    //   this.order.soOrderLineDTOList[0].buyDate = data.buyDate
    //   if(data.buyDate){
    //     const periodStartDate = new Date(data.buyDate); // 复制原始日期
    //     periodStartDate.setFullYear(periodStartDate.getFullYear() + 1);
    //     this.$set( this.order.soOrderLineDTOList[0], 'periodEndDate', periodStartDate);
    //     this.changeGuaranteeType(0,periodStartDate)
    //   }
    //   if (data.buyChannelId){
    //     this.order.soOrderLineDTOList[0].buyChannelId = data.buyChannelId
    //   }

    //   this.order.soOrderLineDTOList[0].instDate =  data.installDate
    //   if (this.order.soOrderLineDTOList[0].bigCategoryId != data.bigCategoryId && data.bigCategoryId!=null) {
    //     this.order.soOrderLineDTOList[0].bigCategoryId = data.bigCategoryId;
    //     this.changeBigCategorys(data.bigCategoryId, 0);
    //   }
    //   this.order.soOrderLineDTOList[0].smallCategoryId = data.smallCategoryId;
    //   this.order.soOrderLineDTOList[0].bigCategoryName = data.bigCategoryName;
    //   this.order.soOrderLineDTOList[0].smallCategoryName = data.smallCategoryName;
    //   if (data.itemId){
    //     this.order.soOrderLineDTOList[0].itemId = data.itemId;
    //   }
    //   this.order.soOrderLineDTOList[0].itemName = data.itemName;
    //   this.order.soOrderLineDTOList[0].itemCode = data.itemCode;
    //   this.order.soOrderLineDTOList[0].outbound = data.unitName;
    //   if (data.periodDate){
    //     this.order.soOrderLineDTOList[0].periodEndDate =  data.periodDate
    //   }
    //   if (data.buyShop){
    //     this.$http({
    //       url: api.basBuyShop.getBuyShopByNameUrl,
    //       method: 'post',
    //       data: {shopName: data.buyShop}
    //     }).then(res => {
    //       if (res.data.data.buyShopId){
    //         this.order.soOrderLineDTOList[0].buyShopId = res.data.data.buyShopId;
    //         this.order.soOrderLineDTOList[0].buyShop = res.data.data.buyShop;
    //         this.buyShopKey +=1
    //       }
    //     })
    //   }
    //   this.$set(this.order, 'areaId', data.areaId)
    //   if (data.areaId !== null && data.areaId !== '') {
    //     // this.cascaderShow = false
    //     this.$set(this.order, 'areaId',null)
    //     this.$http({
    //       url: api.basArea.echoAddressUrl,
    //       method: 'post',
    //       data: {id: data.areaId}
    //     }).then(res => {
    //       // console.log(res)
    //       this.areaOption = res.data.data.options
    //       this.areaValues = res.data.data.values
    //       this.$set(this.order, 'areaId', data.areaId)
    //       // this.area = res.data.data.names
    //     })
    //   }else{
    //     this.areaOption = []
    //     this.areaValues = []
    //   }
    // },


    commitSelectedSiteRow(data,index){
      console.log("二级网点提交数据",data);
      if(data){
        this.order.siteId = data.id
        this.order.siteName = data.name
        this.order.bigSiteName = data.parentSiteName
        if(!data.parentSiteName){
          this.order.bigSiteName = data.name
        }
        //重置地区选择器
        // this.$http({
        //   url: api.basArea.getSiteAdress,
        //   method: "post",
        //   data: {
        //     siteId: this.order.siteId,
        //     parentId: null,
        //   },
        //   isLoading: true,
        //   modalStrictly: true,
        // }).then((response) => {
        //   console.log("目标：")
        //   console.log(response.data.data);
        //   if(this.order.profileNo){
        //     this.order.profileNo = null;
        //   }
        //   if(this.order.userAddress){
        //     this.order.userAddress = null;
        //   }
        //   if(this.order.userMobile){
        //     this.order.userMobile = null;
        //   }
        //   if(this.order.userName){
        //     this.order.userName = null;
        //   }
        //   this.areaOption = [];
        //   this.loadBuyChannelData();
        // });
      }
    },
    //产品选择
    commitSelectedItemRow(data, index) {
      if (this.order.soOrderLineDTOList[index].bigCategoryId != data.bigCategoryId) {
        this.order.soOrderLineDTOList[index].bigCategoryId = data.bigCategoryId;
        this.changeBigCategorys(data.bigCategoryId, index);
      }
      this.order.soOrderLineDTOList[index].smallCategoryId = data.smallCategoryId;
      this.order.soOrderLineDTOList[index].bigCategoryName = data.bigCategoryName;
      this.order.soOrderLineDTOList[index].smallCategoryName = data.smallCategoryName;
      this.order.soOrderLineDTOList[index].itemId = data.id;
      this.order.soOrderLineDTOList[index].itemName = data.name;
      this.order.soOrderLineDTOList[index].itemCode = data.code;
      this.order.soOrderLineDTOList[index].entId = data.entId;
      this.order.soOrderLineDTOList[index].brandId = data.brandId;
      this.order.soOrderLineDTOList[index].qty = 1;
    },
    //选择产品小类
    changeSmallCategorys(val, index) {
      var smallCategory = this.smallCategorys[index].find(item => item.id === this.order.soOrderLineDTOList[index].smallCategoryId)
      this.order.soOrderLineDTOList[index].smallCategoryName = smallCategory.categoryName
      this.order.soOrderLineDTOList[index].itemId = "";
      this.order.soOrderLineDTOList[index].itemCode = "";
      this.order.soOrderLineDTOList[index].itemName = "";
      this.order.soOrderLineDTOList[index].entId = "";
      //重选产品分类清空故障现象
      this.order.issueFaultId = "";
      this.order.issueFaultName = "";
      this.$forceUpdate()
    },
    //获取产品大类
    getBigCategorys() {
      request({
        url: '/basic/basItemCategory/getChildrens',
        method: 'post',
        data: {
          usable: 1,
          categoryType: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.bigCategorys = response.data.data;
      })
    },
    // changeBracode(index){
    //   const barcode = this.order.soOrderLineDTOList[index].barcode;
    //   this.barcodeEntity = {barcode: barcode,index: index}
    //   console.log(this.barcodeEntity)
    // },
    // getCurrent() {
    //   request({
    //     url: '/basic/snUser/getCurrent',
    //     method: 'post',
    //     data: {},
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then(response => {
    //     console.log(response)
    //     let data = response.data.data;
    //     this.order.bigSiteName = data.parentName
    //     if(this.order.bigSiteName){
    //       this.showSelectSIte = true
    //     }else{
    //       this.showSelectSIte = false
    //     }
    //     if(!data.parentName){
    //       this.order.bigSiteName = data.siteName
    //     }
    //     this.order.siteName = data.siteName
    //     this.order.siteId = data.siteId
    //     let d = {id:this.order.siteId ,name:this.order.siteName,parentSiteName:this.order.bigSiteName}
    //     this.commitSelectedRow3(d, 0);
    //   })
    // },
    //获取品牌
    getBrands() {
      request({
        url: '/basic/snCompanyBrand/getBrandList',
        method: 'post',
        data: {
          usable: 1,
          filtrationByUserBind: true
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.brands = response.data.data;
        this.order.soOrderLineDTOList[0].brandId =  response.data.data[0].id
      })
    },
    // 添加
    addItem() {
      this.order.soOrderLineDTOList.push({});
      this.smallCategorys.push([])
    },
    // handleInputChange(row, maxNum) {
    //   this.$nextTick(() => {
    //     let num = Math.min(Number(row.qty), maxNum);
    //     if (num < 0) {
    //       row.qty = 0;
    //     } else {
    //       row.qty = num;
    //       row.remaining = Number(row.qty) - Number(row.installQty);
    //     }
    //   });
    // },
    // promisePeriodMonthChange(row, maxNum) {
    //   this.$nextTick(() => {
    //     let num = Math.min(Number(row.promisePeriodMonth), maxNum);
    //     if (num < 0) {
    //       row.qty = 0;
    //     } else {
    //       row.promisePeriodMonth = num;
    //     }
    //   });
    // },
    // initProjectType() {
    //   this.$http.post("/basic/SoProject/getList").then((res) => {
    //     this.projectTypeList = res.data.data;
    //   });
    // },

    // 地址选中事件
    handleChange(value) {
      console.log(value,"输入的值")
      console.log(
        this.$refs["cascaderAddr"].getCheckedNodes(),
        "选择地址"
      );
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      if (this.keyWord) {
        this.clear()
        this.order.areaId = areaNode[0].value;
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.order.areaId}
        }).then(res => {
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.order.areaId =  res.data.data.areaId
          this.order.userProvice = res.data.data.userProvice;
          this.order.userCity = res.data.data.userCity;
          this.order.userCounty = res.data.data.userCounty;
          this.order.userTown = res.data.data.userTown;
        })
      }
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        this.order.areaId = areaNode.value;
        if (areaNode[0].level == 1) {
          this.order.userProvice = null;
          this.order.userCity = null;
          this.order.userCounty = null;
          this.order.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.order.userProvice = areaNode[0].label;
          this.order.userCity = null;
          this.order.userCounty = null;
          this.order.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.order.userCity = areaNode[0].label;
          this.order.userCounty = null;
          this.order.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.order.userCounty = areaNode[0].label;
          this.order.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.order.userTown = areaNode[0].label;
        }
      }else if(areaNode.length == 0){
        this.showArea=!this.showArea
        setTimeout(() => {
          this.$nextTick(() => {
        this.showArea=!this.showArea
        })
        },10)
      }else {
        if (!this.keyWord) {
          this.order.areaId = null;
          this.order.userProvice = null;
          this.order.userCity = null;
          this.order.userCounty = null;
          this.order.userTown = null;
        }
      }
      // this.order.areaId = null;
      // this.order.userProvice = null;
      // this.order.userCity = null;
      // this.order.userCounty = null;
      // this.order.userTown = null;
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }
    },
     //输入时获取关键词，主要用于判断用户何时清空了关键词
     handleInput(val) {
      this.inputWord = val
    },

    areaBeforeFilter(value){
     this.key++
     this.areaValues = [value]
     this.$nextTick(() => {
       this.$refs["cascaderAddr"].computePresentText();
     });
     this.keyWord = value
     let params = {}
     if (this.keyWord) { //如果有关键词，带上关键词获取，需要接口支持
       params ={
         areaName:this.keyWord,
       }
     }
     this.$http({
       url: api.basArea.getList,
       method: 'post',
       data: params,
       isLoading: true,
       modalStrictly: true,
     }).then(response => {
       let node0 = []
       if (this.keyWord) {
         this.$refs.cascaderAddr.inputValue = this.keyWord
         this.$refs.cascaderAddr.$refs.input.focus()
         this.$refs.cascaderAddr.toggleDropDownVisible()
       }
       const childrens = response.data.data || {};
      //  console.log(childrens,"254  得到了请求数据");
       const childNodes = childrens.map(item => ({
           value: item.id,
           label: item.areaName,
           leaf: Number(item.hasChild) !== 0
         }))
        //  console.log(childNodes,"585");
         if(value==0){
            this.areaOption = ''
            // console.log('2525到这里了99999999999999999');
            return
          }
         this.areaOption = childNodes
     })
     return false
   },
   resetInput() {
     this.$nextTick(() => {
       const that = this.$refs.cascaderAddr
       this.$refs.cascaderAddr.handleInput = function(val, event) {
         that.$emit('myInput', val)
         !that.dropDownVisible && that.toggleDropDownVisible(true)
         if (event && event.isComposing) return
         if (val) {
           that.filterHandler()
         } else {
           that.filtering = false
         }
       }
     })
   },
// 清空选中时，重置下拉选项，清空输入，默认展开下拉面板
   clear() {
    //  console.log("11111222")
     this.keyWord = ''
   },
   cascaderLazyLoad(node, resolve) {
     console.log(node, resolve,'152');
     if (!node) {
       return false
     }
     this.order.areaId = node.value;
     this.resetInput()
     let params = {parentId: node.value}
     // if (this.keyWord) { //如果有关键词，带上关键词获取，需要接口支持
     //   params ={
     //     areaName:this.keyWord,
     //     parentId: node.value
     //   }
     // }
     if (this.keyWord) {
       return
     }
     this.$http({
       url: api.basArea.getList,
       method: 'post',
       data: params,
       isLoading: true,
       modalStrictly: true,
     }).then(response => {
       let node0 = []
       console.log()
       if (node.root) {
         const childrens = response.data.data || {};
         const childNodes = childrens.map(item => ({
           value: item.id,
           label: item.areaName,
           leaf: Number(item.hasChild) !== 0
         }))
         // 通过调用resolve将子节点数据返回，通知组件数据加载完成
         resolve(childNodes);
       } else {
         const childrens = response.data.data || {};
         let childNodes = []
         let temp = ''
         if (node.children.length !== 0) {
           temp = node.children
           childrens.forEach(item => {
             let flag = false
             temp.forEach(item1 => {
               if (item1.value == item.id) {
                 flag = true  // 当前节点已存在此数据，不追加
               }
             })
             if (!flag) {
               childNodes.push({
                 value: item.id,
                 label: item.areaName,
                 leaf: Number(item.hasChild) !== 0
               })
             }
           })
           resolve(childNodes);
         } else {
           childrens.forEach(item => {
             childNodes.push({
               value: item.id,
               label: item.areaName,
               leaf: Number(item.hasChild) !== 0
             })
           })
           resolve(childNodes);
         }
       }
     })
   },

    // handleChange() {
    //   const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
    //   console.log('cascaderAddr', areaNode)
    //   if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
    //     if (areaNode[0].level == 1) {
    //       this.order.country = areaNode[0].label;
    //       this.order.province = null;
    //       this.order.city = null;
    //       this.order.county = null;
    //       this.order.town = null;
    //     } else if (areaNode[0].level == 2) {
    //       this.order.province = areaNode[0].label;
    //       this.order.city = null;
    //       this.order.county = null;
    //       this.order.town = null;
    //     } else if (areaNode[0].level == 3) {
    //       this.order.city = areaNode[0].label;
    //       this.order.county = null;
    //       this.order.town = null;
    //     } else if (areaNode[0].level == 4) {
    //       this.order.country = areaNode[0].label;
    //       this.order.town = null;
    //     } else if (areaNode[0].level == 5) {
    //       this.order.town = areaNode[0].label;
    //     }
    //     this.order.areaId = areaNode[0].value
    //   } else {
    //     this.order.areaId = null;
    //     this.order.country = null;
    //     this.order.province = null;
    //     this.order.city = null;
    //     this.order.county = null;
    //     this.order.town = null;
    //   }
    //   const panelRefs = this.$refs.cascader.$refs.panel
    //   if (panelRefs.activePath.length !== 0) {
    //     panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
    //   }
    // },

    // handleChange() {
    //   const areaNode = this.$refs["cascader"].getCheckedNodes();
    //   console.log("handleNode", areaNode);
    //   if (
    //     areaNode != null &&
    //     areaNode[0] != null &&
    //     areaNode[0].value != null
    //   ) {
    //     if (areaNode[0].level == 1) {
    //       this.order.deliverProvince =areaNode[0].label;
    //       this.order.deliverCity = null;
    //       this.order.deliverCounty = null;
    //       this.order.deliverTown = null;
    //     } else if (areaNode[0].level == 2) {
    //       console.log("level2："+areaNode[0].label)
    //       this.order.deliverCity = areaNode[0].label;
    //       this.order.deliverCounty = null;
    //       this.order.deliverTown = null;
    //     } else if (areaNode[0].level == 3) {
    //       console.log("level3："+areaNode[0].label)
    //       this.order.deliverCounty = areaNode[0].label;
    //       if(!areaNode[0].hasChildren){
    //         this.$refs.cascader.dropDownVisible = false;

    //       }
    //     } else if (areaNode[0].level == 4) {
    //       console.log("level4："+areaNode[0].label)
    //       this.order.deliverTown =  areaNode[0].label;
    //       this.$refs.cascader.dropDownVisible = false;

    //     }
    //     this.order.areaId = areaNode[0].value;
    //   } else {
    //     this.order.areaId = null;
    //     this.order.country = null;
    //     this.order.deliverProvince = null;
    //     this.order.deliverCity = null;
    //     this.order.deliverCounty = null;
    //     this.order.deliverTown = null;
    //   }

    //   const panelRefs = this.$refs.cascader.$refs.panel;
    //   if (panelRefs.activePath.length !== 0) {
    //     panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0]);
    //   }
    // },

    validateTime() {
      const selectedDate = new Date(this.order.wishBookDate); // 将选择的日期转换为Date对象
      const currentTime = new Date(); // 当前时间
      selectedDate.setHours(0, 0, 0, 0); // 将选择的时间设置为当天的0点0分0秒
      currentTime.setHours(0, 0, 0, 0);
      if (selectedDate < currentTime) {
        // 如果选择的日期与当前日期相同，并且选择的时间小于当前时间，则重置选择框的值
        this.order.wishBookDate = '';
        this.$message.error('选择的日期不能小于当前日期');
      }
    },
    // 地址懒加载
    // cascaderLazyLoad(node, resolve) {
    //   if (!node) {
    //     return false;
    //   }
    //   if(node.value && !this.order.siteId){
    //     this.$message.warning('请先选择网点');
    //     return false;
    //   }
    //   this.$http({
    //     url: api.basArea.getSiteAdress,
    //     method: "post",
    //     data: {
    //       siteId: this.order.siteId,
    //       parentId: node.value,
    //     },
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then((response) => {
    //     if (node.root) {
    //       const childrens = response.data.data || {};
    //       const childNodes = childrens.map((item) => ({
    //         value: item.id,
    //         label: item.areaName,
    //         leaf: Number(item.hasChild) !== 0,
    //       }));
    //       console.log("childNodes", childNodes);
    //       // 通过调用resolve将子节点数据返回，通知组件数据加载完成
    //       resolve(childNodes);
    //     } else {
    //       const childrens = response.data.data || {};
    //       let childNodes = [];
    //       let temp = "";
    //       console.log(node.children, "child");
    //       if (node.children.length !== 0) {
    //         temp = node.children;
    //         childrens.forEach((item) => {
    //           let flag = false;
    //           temp.forEach((item1) => {
    //             if (item1.value == item.id) {
    //               flag = true; // 当前节点已存在此数据，不追加
    //             }
    //           });
    //           if (!flag) {
    //             childNodes.push({
    //               value: item.id,
    //               label: item.areaName,
    //               leaf: Number(item.hasChild) !== 0,
    //             });
    //           }
    //         });
    //         resolve(childNodes);
    //       } else {
    //         childrens.forEach((item) => {
    //           childNodes.push({
    //             value: item.id,
    //             label: item.areaName,
    //             leaf: Number(item.hasChild) !== 0,
    //           });
    //         });
    //         resolve(childNodes);
    //       }
    //     }
    //   });
    // },

    changeBrandId(index){
      this.order.soOrderLineDTOList[index].bigCategoryId ="";
      this.order.soOrderLineDTOList[index].smallCategoryId="";
      this.order.soOrderLineDTOList[index].itemCode="";
      this.order.soOrderLineDTOList[index].itemName="";
      this.order.soOrderLineDTOList[index].itemId="";
    },
    // 地址数据回显
    // echoAddress() {
    //   if (this.order.areaId && this.order.areaId != 0) {
    //     this.$http
    //       .post(api.basArea.echoAddressUrl, { id: this.order.areaId })
    //       .then((res) => {
    //         console.log(res);
    //         this.areaOption = res.data.data.options;
    //         this.areaValues = res.data.data.values;
    //         this.area = res.data.data.names;
    //       });
    //   }
    // },

    // resetInput() {
    //   this.$nextTick(() => {
    //     const that = this.$refs.cascaderAddr;
    //     this.$refs.cascaderAddr.handleInput = function (val, event) {
    //       that.$emit("myInput", val);
    //       !that.dropDownVisible && that.toggleDropDownVisible(true);
    //       if (event && event.isComposing) return;
    //       if (val) {
    //         that.filterHandler();
    //       } else {
    //         that.filtering = false;
    //       }
    //     };
    //   });
    // },

    // closeD2(v) {
    //   console.log(v, "v的值");
    //   this.showFamilyMobileDialog = v;
    // },

    // showFamilyMobile(assetId) {
    //   this.showFamilyMobileDialog = true;
    //   this.assetId = assetId;
    // },

    // openRecordDialog(e) {
    //   console.log(e, "点击的权益id");
    //   this.areaObj3 = e;
    //   this.recordDialog = true;
    // },
    // getDictTypes() {
    //   this.$http({
    //     url: "/admin/dict/type/VIP级别",
    //     method: "get",
    //   }).then((res) => {
    //     this.dictTypesVipLevel = res.data.data;
    //   });
    //   this.$http({
    //     url: "/admin/dict/type/来电信息",
    //     method: "get",
    //   }).then((res) => {
    //     this.dictTypesCallInfo = res.data.data;
    //   });
    //   this.$http({
    //     url: "/admin/dict/type/性格类型",
    //     method: "get",
    //   }).then((res) => {
    //     this.dictTypesNatureType = res.data.data;
    //   });
    //   this.$http({
    //     url: "/admin/dict/type/文化水平",
    //     method: "get",
    //   }).then((res) => {
    //     this.dictTypesEducationLevel = res.data.data;
    //   });
    //   this.$http({
    //     url: "/admin/dict/type/用户身份",
    //     method: "get",
    //   }).then((res) => {
    //     this.dictTypesCustIdentity = res.data.data;
    //   });
    //   this.$http({
    //     url: "/admin/dict/type/风险把控",
    //     method: "get",
    //   }).then((res) => {
    //     this.dictTypesCustRisk = res.data.data;
    //   });
    // },
    closeD() {
      this.drawer = false;
    },
    // 明细勾选
    // selectAddressChangeEvent(data) {
    //   this.selectAddressData = data.records;
    // },
    // selectItemChangeEvent(data) {
    //   this.selectItemData = data.records;
    // },

    // 资产删除
    // deleteAsse() {
    //   this.$baseConfirm("您确定要删除已选资产吗？").then(() => {
    //     let temp = this.order.basCustAsseList;
    //     this.selectItemData.forEach((item) => {
    //       temp = temp.filter((item1) => item1.id != item.id);
    //     });
    //     this.order.basCustAsseList = temp;
    //   });
    // },
    // currentChange({ row }) {
    //   console.log("row", row);
    //   this.selectItemData = [row];
    //   if (row.id) {
    //     // this.showParts = false
    //     this.$http({
    //       url: api.basCustAsset.getPartsDataUrl,
    //       method: "post",
    //       data: {
    //         id: row.id,
    //       },
    //     }).then((res) => {
    //       if (res.data.data.length !== 0 && res.data.data[0] != null) {
    //         this.partsList = res.data.data;
    //         console.log(this.partsList, "partsList的值");
    //       } else {
    //         this.partsList = [];
    //       }
    //     });
    //   } else {
    //     console.log("kong");
    //     this.partsList = [];
    //   }
    //   // this.reload()
    //   // this.$refs['aaaa'].commitProxy('reload');
    // },

    // editArea(row) {
    //   this.areaObj = row;
    //   this.showAreaDialog = true;
    // },

    edit(row) {
      this.obj = row;
      this.showPreconditionDialog = true;
      // this.openTheNewPopover(true, data)
    },
    // 故障现象弹框
    selectFault() {
      if (!this.isShowFault) {
        if (this.order.soOrderLineDTOList[0].bigCategoryId != null && this.order.soOrderLineDTOList[0].bigCategoryId != ""
        ) {
          this.faultDialogParam.bigCategoryId = this.order.soOrderLineDTOList[0].bigCategoryId;
          this.faultDialogParam.smallCategoryId = this.order.soOrderLineDTOList[0].smallCategoryId;
          this.showFaultDialog = true;
        } else {
          this.$message({message: '请先选择对应的产品大类', type: 'warning'});
        }
      }
    },
    //确定选择故障现象
    commitFaultSelected(data) {
      this.order.issueFaultId = data.id;
      this.order.issueFaultName = data.name;
    },
    // 加载机构数据
    // loadOrgData() {
    //   this.$http({
    //     url: api.sysDept.getDataUrl,
    //     method: "post",
    //     data: {},
    //   }).then((res) => {
    //     console.log(res.data.data);
    //     this.orgOptions = [];
    //     res.data.data.forEach((item) => {
    //       let temp = {
    //         value: item.id,
    //         label: item.name,
    //       };
    //       if (item.hasChild) {
    //         temp.children = [];
    //         item.child.forEach((item1) => {
    //           temp.children.push({
    //             value: item1.deptId,
    //             label: item1.name,
    //           });
    //         });
    //       }

    //       this.orgOptions.push(temp);
    //     });
    //   });
    // },

    // orgHandleChange(data) {
    //   if (data.length !== 0) {
    //     this.$http({
    //       url: "/admin/dept/" + data[data.length - 1],
    //       method: "get",
    //     }).then((res) => {
    //       console.log("选中机构", res.data.data);
    //       this.order.orgId = res.data.data.deptId;
    //       this.order.orgName = res.data.data.name;
    //       this.order.orgIdPath = res.data.data.orgIdPath;
    //     });
    //   }
    // },

    // commitAreaData(data) {
    //   let filter = this.order.basCustAddressList.filter(
    //     (item) => item.id != data.id
    //   );
    //   if (data.isDefault == 1) {
    //     filter.forEach((item) => {
    //       item.isDefault = 0;
    //     });
    //   }
    //   filter.push(data);

    //   this.order.basCustAddressList = filter;
    // },

    // commitData(data) {
    //   console.log(data, "commitData");
    //   let temp = this.order.basCustAsseList.filter(
    //     (item) => item.id != data.id
    //   );
    //   temp.push(data);
    //   this.order.basCustAsseList = temp;
    //   if (isRefresh) {
    //     this.getTableData();
    //   } else {
    //     if (this.order.basCustAsseList.length !== 0) {
    //       this.order.basCustAsseList = this.order.basCustAsseList.filter(
    //         (item) => item.id !== data.id
    //       );
    //     }
    //     this.order.basCustAsseList.push(data);
    //   }
    //   console.log(this.order.basCustAsseList, "---------");
    // },

    //新增产品按钮功能
    // openTheNewPopover(flag, data) {
    //   if (flag) {
    //     this.obj = data;
    //   } else {
    //     this.obj = {
    //       profileId: "",
    //       id: "",
    //       brand: { value: "", label: "" },
    //       barcode: "",
    //       barcode2: "",
    //       stat: 1,
    //       brandId: "",
    //       brandName: "",
    //       itemId: "",
    //       itemCode: "",
    //       itemName: "",
    //       bigCategoryId: "",
    //       bigCategoryName: "",
    //       smallCategoryId: "",
    //       smallCategoryName: "",
    //       extendPeriodMonth: 0,
    //       standPeriodMonth: 0,
    //       careDate: "",
    //       fixDate: "",
    //       instDate: "",
    //       picList1: [],
    //       picList2: [],
    //       picList3: [],
    //       activeStat: 0,
    //       repairCardNo: "",
    //       contractFile: [],
    //     };
    //   }
    //   this.obj.profileId = this.dataId !== "" ? this.dataId : "";
    //   console.log(this.obj);
    //   this.showPreconditionDialog = true;
    // },

    // 回显
    // getData() {
    //   if (this.dataId && !isNaN(this.dataId)) {
    //     this.isEdit = true;
    //     this.$http
    //       .get("/basic/SoProject/getById", {
    //         params: {
    //           id: this.dataId,
    //         },
    //       })
    //       .then((response) => {
    //         console.log("res", response.data.data);
    //         this.order = response.data.data;
    //         this.echoAddress();
    //       });
    //   }
    // },

    saveData() {
      console.log(this.order,"保存前的值");
      if (!this.order.siteId || this.order.siteId==null) {
          this.$message.error("请选择服务商！");
          return;
        }
        if (!this.order.userName || this.order.userName==null) {
          this.$message.error("请填写用户姓名！");
          return;
        }
        if (!this.order.userMobile||this.order.userMobile.length !== 11) {
          this.$message.error("联系电话格式不对！");
          return;
        }
        if (!this.order.userAddress || this.order.userAddress==null) {
          this.$message.error("请填写详细地址！");
          return;
        }
        if (!this.order.areaId){
          this.$message({message: '缺失地址id,请选择重新选择地址', type: 'warning'});
          return;
        }
        if (!this.order.serviceTypeId || this.order.serviceTypeId==null) {
          this.$message.error("请选择服务类型！");
          return;
        }
        if (!this.order.appeals) {
          this.$message.error("请填写客户诉求！");
          return;
        }
      var isMissBigCategoryId = false;
      var isBrandId = false;
      var isBuyChannel = false;
      var isBuyDate = false;
      var isItem = false;
      var isBuyShop = false
      this.order.soOrderLineDTOList.forEach(item => {
        if(!item.brandId ){
          isBrandId = true;
        }
        if(!item.buyDate){
          isBuyDate = true;
        }
        if(!item.buyShopId){
          isBuyShop = true;
        }
        if(!item.itemId ){
          isItem = true;
        }
        if (!item.bigCategoryId){
          isMissBigCategoryId = true
        }
        // if (this.serviceTypedValue!=4 && !item.bigCategoryId){
        //   isMissBigCategoryId = true
        // }
        // else if((this.serviceTypedValue==4 || this.serviceTypedValue == 11 || this.serviceTypedValue == 13) && !item.bigCategoryId){
        //   item.bigCategoryId = 0;
        //   item.bigCategoryName = '未知'
        // }
        if (!item.buyChannelId){
          isBuyChannel = true;
        }
      });
      // if(isBuyChannel){
      //   this.$message({message: '产品项缺少销售类型', type: 'warning'});
      //   return;
      // }
      if (isBuyDate){
        this.$message({message: '产品项缺购买时间', type: 'warning'});
        return;
      }
      // if (isBuyShop){
      //   this.$message({message: '产品项缺购买商场', type: 'warning'});
      //   return;
      // }
      if (isItem) {
        this.$message({message: '缺失产品id,请重新选择产品!', type: 'warning'});
        return;
      }
      if (isBrandId) {
        this.$message({message: '品牌必填', type: 'warning'});
        return;
      }
      if (isMissBigCategoryId) {
        this.$message({message: '产品大类必填', type: 'warning'});
        return;
      }
        this.order.serverTypeId = this.order.serviceTypeId;
        // this.order.userCity = this.order.deliverCity;
        // this.order.userCounty = this.order.deliverCounty;
        // this.order.userTown = this.order.deliverTown;
        this.$mask.open()
        request({
          url: '/basic/soOrderIssue/doSaveOrderForSite',
          method: 'post',
          data: this.order,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log("response----", response)
          if (response.data.code == 0) {
            if (response.data.data.indexOf("操作成功") !== -1) {
              this.$message({message: response.data.data, type: 'success'});
            } else {
              this.$message({message: response.data.data, type: 'warning'});
            }
            this.reload()
            this.$mask.close()
          } else {
            this.$message({message: response.data.content, type: 'error'});
            this.$mask.close()
          }
        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！");
          this.$mask.close()
        });
    },

    // check() {
    //   this.$refs.editForm.validate((valid) => {
    //     if (valid) {
    //       this.$baseConfirm("您确定要审核通过吗？").then(() => {
    //         this.$http
    //           .get("/basic/SoProject/examineById", {
    //             params: {
    //               id: this.order.id,
    //             },
    //           })
    //           .then((res) => {
    //             this.$message.success("审核成功！");
    //             this.reload();
    //           })
    //           .catch((e) => {
    //             console.error(e);
    //             this.$message.error("审核失败！");
    //           });
    //       });
    //     }
    //   });
    // },

    // reject() {
    //   this.$refs.editForm.validate((valid) => {
    //     if (valid) {
    //       this.$baseConfirm("确认提交？").then(() => {
    //         this.$http
    //           .get("/basic/SoProject/submitById", {
    //             params: {
    //               id: this.order.id,
    //             },
    //             // isLoading: true,
    //           })
    //           .then((res) => {
    //             this.$message.success("提交成功！");
    //             // this.$emit('editViewDataUpdate')
    //             // this.$baseReload()
    //             this.reload();
    //           })
    //           .catch((e) => {
    //             console.error(e);
    //             this.$message.error("提交失败！");
    //           });
    //       });
    //     }
    //   });
    // },

    // openEditDialog(row) {
    //   if (this.dataId !== "") {
    //     this.$http({
    //       url: this.getDataUrl1,
    //       method: "post",
    //       data: { id: row.id },
    //     }).then((res) => {
    //       this.obj = res.data.data;
    //       this.obj.brand = {
    //         value: this.obj.brandId,
    //         label: this.obj.brandName,
    //       };
    //       this.showPreconditionDialog = true;
    //     });
    //   } else {
    //     console.log(row);
    //     this.obj = row;
    //     this.obj.brand = { value: row.brandId, label: row.brandName };
    //     this.showPreconditionDialog = true;
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
#containt .table-detail tbody tr th {
  white-space: nowrap;
  width: 6vw;
}

#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
}

.btn_zdy {
  // margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #fbfbfb !important;
}

.btn_zdy:hover {
  color: #2a6494 !important;
  border: 1px solid #2a6494 !important;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #2a6494;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// 右边卡片样式
.card {
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;

  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  background-color: #f2f2f2;
  padding-left: 10px !important;
  padding-right: 5px;
  padding-bottom: 20px;
  margin-bottom: 20px;

  .card-item1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      font-size: 13px;
      font-weight: 550;
    }

    .details {
      text-decoration: underline;
      color: #2a6494 !important;
    }
  }

  >div {
    margin-bottom: 8px;
  }
}

.el-scrollbar__wrap {
  margin-bottom: -16px !important;
}

.el-drawer.ltr,
.el-drawer.rtl {
  height: 100%;
  top: 0;
  bottom: 0;
  background-color: #cbcbcb;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.information {
  padding: 4px 10px;
  background-color: #e1f2ff;
  color: #268aea;
  border-radius: 3px;
  margin: 0 5px;
}

// 权益条款
.clause {
  text-decoration: underline;
  color: #000;
}
</style>
